import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ChangeRequestStatusRequest } from '@app/generated-api/models/ChangeRequestStatusRequest';
import { GetAvailableStatusResponse } from '@app/generated-api/models/GetAvailableStatusResponse';
import { RequestType } from '@app/v2/enums/request-types.enum';
import { createLazyLoadedState } from '@app/v2/utility';
import { getSiteBaseUrl } from '@utility/utility';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'any',
})
export class RequestService {
    http = inject(HttpClient);
    readonly submittedRequestsCount = createLazyLoadedState(() => ({
        fetch$: () => this.http.get<number>(`${getSiteBaseUrl()}/api/v2/requests/submitted/count`),
    }));

    getAvailableStatus: (requestId: number, requestType: RequestType) => Observable<GetAvailableStatusResponse[]> = (
        requestId: number,
        requestType: RequestType
    ) => {
        return this.http.get<GetAvailableStatusResponse[]>(
            `${getSiteBaseUrl()}/api/v2/requests/available-status/${requestType}/${requestId}`
        );
    };

    changeStatus(request: ChangeRequestStatusRequest): Observable<number> {
        return this.http.put<number>(`${getSiteBaseUrl()}/api/v2/requests/change-status`, request);
    }
}
